// extracted by mini-css-extract-plugin
export default {"bigImage":"ProductBigImage_bigImage__RXCGw"};